import { Helmet } from 'react-helmet-async';
import PageBanner from '@components/Common/PageBanner';
import VideoSection from '@components/Common/VideoSection';
import Testimonials from '@components/Common/Testimonials';
import './VR.css';

const VR = () => {
    const features = [
        {
            icon: 'bi-headset-vr',
            title: 'Immersive Walkthroughs',
            description: 'Experience your future space in virtual reality before construction begins.'
        },
        {
            icon: 'bi-phone',
            title: 'AR Visualization',
            description: 'See how designs fit in your actual space using augmented reality.'
        },
        {
            icon: 'bi-people',
            title: 'Collaborative Design',
            description: 'Review and modify designs with stakeholders in real-time VR sessions.'
        },
        {
            icon: 'bi-rulers',
            title: 'Accurate Scaling',
            description: 'Get a true sense of space, proportion, and scale before building.'
        },
        {
            icon: 'bi-lightbulb',
            title: 'Design Iterations',
            description: 'Quickly visualize and compare different design options.'
        },
        {
            icon: 'bi-graph-up',
            title: 'Better Decisions',
            description: 'Make informed decisions with immersive visualization technology.'
        }
    ];

    return (
        <>
            <Helmet>
                <title>VR & AR in Architecture - AT Architects</title>
                <meta name="description" content="Explore how VR and AR technology transforms architectural design and client experience." />
            </Helmet>

            <PageBanner
                title="Architect's Futuristic Vision"
                subtitle="VR & AR Uses in Architecture and Design"
                backgroundImage="/images/vr-banner.jpg"
            />

            <section className="vr-features-section">
                <div className="vr-container">
                    <div className="vr-intro">
                        <h2>The Future of Architectural Visualization</h2>
                        <p>Virtual and Augmented Reality are revolutionizing how we design, present, and experience architecture.</p>
                    </div>

                    <div className="vr-features-grid">
                        {features.map((feature, index) => (
                            <div key={index} className="vr-feature-card">
                                <div className="vr-feature-icon">
                                    <i className={feature.icon}></i>
                                </div>
                                <h3>{feature.title}</h3>
                                <p>{feature.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <VideoSection />
            <Testimonials />
        </>
    );
};

export default VR;
